import { h, VNode } from 'vue';
import { isString, withInstall } from '@mts-fe/utils';
import _MIcon from './src/MIcon.vue';
import SvgIcon from './src/SvgIcon.vue';

export { SvgIcon };
export const MIcon = withInstall(_MIcon);

/** 图标：支持@ant-design/icons-vue、svg与iconfont形式 */
export const Icon = ({ icon, ...rest }: { icon: VNode | string | undefined }) => {
  if (!icon) return null;
  return isString(icon) ? h(MIcon, { icon, ...rest }) : h(icon, rest);
};

export type IconPrefix = 'pc' | 'pad' | 'menu' | 'g';

// export { default as HomeOutlined } from '@ant-design/icons-vue/HomeOutlined';
